module.exports = __webpack_public_path__ + "img/dent2018-dent-red.66042a05.svg";